import { MosaicTocSectionClass } from "./MosaicTocSectionClass";
import type { IMosaicTocExpanded, ITocActionSaveSuccess } from "./interface";

/**
 * Clears local save markers after a successful ToC save.
 *
 * @param state - The current expanded ToC state.
 * @param action - The action containing the successful save timestamp.
 * @returns The updated ToC state after the save succeeds.
 */
export const toc_saveSuccess = (
  state: IMosaicTocExpanded,
  action: ITocActionSaveSuccess,
): IMosaicTocExpanded => {
  const newState: IMosaicTocExpanded = { ...state };

  newState.tocItems.forEach((item) => {
    if (item instanceof MosaicTocSectionClass) {
      item.markSaved();
    } else {
      item.inError = false;
      item.changed = false;
    }
  });
  newState.saving = false;
  newState.blocked = false;
  newState.saveError = false;
  newState.changed = false;
  newState.sendUpdate = true;
  newState.lastMinorVersionSavedAt = action.saveTimeStamp;

  return newState;
};
